import React, { useState } from "react";
import image1 from "../Assets/Gallery/img1.png";
import image2 from "../Assets/Gallery/img2.png";
import image3 from "../Assets/Gallery/img3.png";
import image4 from "../Assets/Gallery/img4.png";
import image8 from "../Assets/Gallery/img5.png";
import image5 from "../Assets/Gallery/img7.png";
import image6 from "../Assets/Gallery/img8.png";
import image7 from "../Assets/Gallery/img9.png";
import image10 from "../Assets/Gallery/img10.png";
import image11 from "../Assets/Gallery/img11.png";
import image12 from "../Assets/Gallery/img12.png";

import { IoMdClose } from "react-icons/io";

const ImageGrid = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null); // state to store selected image index
  const images = [
    { src: image1, alt: "Image 1" },
    { src: image2, alt: "Image 2" },
    { src: image3, alt: "Image 3" },
    { src: image8, alt: "Image 4" },
    { src: image4, alt: "Image 5" },
    { src: image5, alt: "Image 6" },
    { src: image6, alt: "Image 7" },
    { src: image7, alt: "Image 8" },
    { src: image10, alt: "Image 10" },
    { src: image11, alt: "Image 11" },
    { src: image12, alt: "Image 12" },
  ];

  const openModal = (index) => {
    setSelectedImageIndex(index); // set the index of clicked image to display in modal
  };

  const closeModal = () => {
    setSelectedImageIndex(null); // close the modal by clearing the selected image index
  };

  const handleNext = () => {
    if (selectedImageIndex < images.length - 1) {
      setSelectedImageIndex(selectedImageIndex + 1); // move to next image
    } else {
      setSelectedImageIndex(0); // if at the end, loop back to the first image
    }
  };

  const handlePrevious = () => {
    if (selectedImageIndex > 0) {
      setSelectedImageIndex(selectedImageIndex - 1); // move to previous image
    } else {
      setSelectedImageIndex(images.length - 1); // if at the beginning, loop to the last image
    }
  };

  return (
    <div className="gallery-container text-center my-[3%]">
      <h1 className="text-2xl font-bold text-center font-[Franklin_Gothic_Medium], Arial_Narrow, Arial, 
      sans-serif w-[150px] border-b-2 border-gray-500 mx-auto" >
        Our Gallery
      </h1>
      {/* <hr className="border-b-2 border-gray-500 w-[10%] mx-auto mt-2" /> */}
      <div className="grid-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-6 gap-2 p-5 grid-rows-[repeat(4,_150px)]">
        {images.map((image, index) => (
          <div
            key={index}
            className={`${index === 0 ? "col-span-2 row-span-2" : ""} ${
              index === 1 ? "col-span-1 row-span-2" : ""
            } ${index === 2 ? "col-span-1 row-span-1" : ""} ${
              index === 3 ? "col-span-2 row-span-2" : ""
            } ${index === 4 ? "col-span-1 row-span-1" : ""} ${
              index === 5 ? "col-span-3 row-span-2" : ""
            } ${index === 6 ? "col-span-2 row-span-2" : ""} ${
              index === 7 ? "col-span-1 row-span-2" : ""
            } ${index === 8 ? "col-span-2 row-span-1" : ""}  ${
              index === 9 ? "col-span-2 row-span-1" : ""
            } ${index === 10 ? "col-span-2 row-span-1" : ""}`}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover block rounded-lg shadow-md border border-white transition-transform duration-300 ease-in-out hover:scale-105"
              onClick={() => openModal(index)} // pass index to open modal
            />
          </div>
        ))}
      </div>
      {/* Modal */}
      {selectedImageIndex !== null && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
          onClick={closeModal}
        >
          <div
            className="relative"
            onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside it
          >
            <img
              src={images[selectedImageIndex].src}
              alt={images[selectedImageIndex].alt}
              className="max-w-full max-h-screen object-contain rounded-lg"
            />
            <button
              onClick={closeModal}
              className="absolute top-2  right-3 text-white text-l font-bold bg-black p-2 rounded-full"
            >
              <IoMdClose />
            </button>
          </div>
        </div>
      )}
      {/* Next and Previous Buttons outside modal */}
      {selectedImageIndex !== null && (
        <>
          <button
            onClick={handlePrevious}
            className="fixed left-0 top-1/2 transform -translate-y-1/2 text-white text-3xl bg-black rounded-full p-3 z-50"
            style={{ top: "50%", transform: "translateY(-50%)" }}
          >
            &lt;
          </button>
          <button
            onClick={handleNext}
            className="fixed right-0 top-1/2 transform -translate-y-1/2 text-white text-3xl bg-black rounded-full p-3 z-50"
            style={{ top: "50%", transform: "translateY(-50%)" }}
          >
            &gt;
          </button>
        </>
      )}
    </div>
  );
};

export default ImageGrid;
